export default __webpack_public_path__ + "static/media/footer-watermark.ec11c3f7.png";